import { server } from 'helpers/config';

const SERVER_URL = server.apiHost;

export default {
  KNOWLEDGE_BASE: `${SERVER_URL}/t2b/documents/kw-articles/`,
  UPDATE: 'update/',
}

